"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResponseCanceled = void 0;
/**
 * Если запрос был отменен возвращает true
 * @param errorMessage - сообщение из response
 */
var isResponseCanceled = function (errorMessage) {
    return errorMessage === 'canceled';
};
exports.isResponseCanceled = isResponseCanceled;
